var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H12.5C12.7761 4 13 4.22386 13 4.5V11C13 11.5523 12.5523 12 12 12H4C3.44772 12 3 11.5523 3 11",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L3.37404 4.91603C2.96242 4.64161 3.15668 4 3.65139 4H12.3486C12.8433 4 13.0376 4.64161 12.626 4.91602L8 8Z",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInAdvance);
export default __webpack_public_path__ + "static/media/Send_in_advance.091a45d3c1bcfdf187d2315e6e3de3dd.svg";
export { ForwardRef as ReactComponent };